<template>
  <div class="feeConfig">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">标的物配置</div>
      </div>
      <div class="table-container">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          size="medium"
          border
        >
          <i slot="empty" style="font-style: normal">暂无数据</i>
          <el-table-column
            type="index"
            label="序号"
            width="70"
            align="center"
          />
          <el-table-column
            prop="typeName"
            label="标的物类型"
            align="center"
            width="160"
            show-overflow-tooltip
          />
          <el-table-column
            prop="name"
            label="费用类型"
            align="center"
            width="180"
          />
          <el-table-column label="金额" align="center" min-width="220">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.editing"
                v-model="scope.row.feeAmount"
                size="small"
                class="amount-input"
                clearable
              />
              <span v-else>{{ formatAmount(scope.row.feeAmount) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="unitText"
            label="单位"
            align="center"
            width="160"
          />
          <el-table-column v-if="edit" label="操作" align="center" width="120">
            <template slot-scope="scope">
              <span
                v-if="scope.row.editing"
                class="content-edit"
                @click="saveEdit(scope.row)"
              >确认</span>
              <span
                v-else
                class="content-edit"
                @click="startEdit(scope.row)"
              >编辑</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from "@/common/MixIn.js";
import {
  listPropertyConfig,
  updatePropertyConfig,
  leaseRequestError
} from "@/service/fishPondLease";

export default {
  name: "FeeConfig",
  mixins: [mixins],
  data() {
    return {
      loading: false,
      tableData: []
    };
  },
  async mounted() {
    await this.initPagePermission();
    this.loadList();
  },
  methods: {
    formatAmount(value) {
      const number = Number(value);
      return isNaN(number) ? "0" : number.toString();
    },
    loadList() {
      this.loading = true;
      listPropertyConfig()
        .then(res => {
          const groups = (res && res.data) || [];
          this.tableData = (Array.isArray(groups) ? groups : []).reduce(
            (rows, group) =>
              rows.concat(
                (group.feeItems || []).map(item => ({
                  ...item,
                  type: group.type,
                  typeName: group.typeName,
                  editing: false,
                  originalAmount: Number(item.feeAmount || 0)
                }))
              ),
            []
          );
        })
        .catch(err => {
          this.$message.error(leaseRequestError(err));
          this.tableData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    startEdit(row) {
      this.tableData.forEach(item => {
        if (item.editing) {
          item.feeAmount = item.originalAmount;
        }
        item.editing = false;
      });
      row.originalAmount = Number(row.feeAmount || 0);
      row.feeAmount = this.formatAmount(row.originalAmount);
      row.editing = true;
    },
    saveEdit(row) {
      const amount = Number(row.feeAmount);
      if (isNaN(amount) || amount < 0 || amount > 999999.99) {
        this.$message.warning("金额应在 0 到 999999.99 之间");
        return;
      }
      updatePropertyConfig({
        attrDefId: row.attrDefId,
        feeAmount: amount
      })
        .then(() => {
          row.feeAmount = amount;
          row.originalAmount = amount;
          row.editing = false;
          this.$message.success("保存成功");
        })
        .catch(err => {
          row.feeAmount = row.originalAmount;
          this.$message.error(leaseRequestError(err));
        });
    }
  }
};
</script>

<style scoped>
.feeConfig .table-container {
  padding: 16px 20px 24px;
  background: #fff;
}

.content-edit {
  color: #409eff;
  cursor: pointer;
}

.feeConfig .amount-input {
  width: 160px;
}

.feeConfig .table-container >>> .amount-input .el-input__inner {
  height: 28px;
  line-height: 28px;
}
</style>
